
    <modal style="z-index: 2017" #modal
           [tabindex]="alert$.tabindex"
           [size]="alert$.size"
           [animation]="alert$.animation"
           [keyboard]="alert$.keyboard"
           [backdrop]="alert$.backdrop"
           (onOpen)="alert$.onOpen($event)"
           (onDismiss)="alert$.onDismiss($event); _lockOpen = false;"
           (onClose)="alert$.onClose($event); _lockOpen = false;">
      <div *ngIf="alert$.title" class="modal-header">
        <h4 class="modal-title" [innerHTML]="alert$.title"></h4>
      </div>
      <div *ngIf="alert$.message" class="modal-body" [innerHTML]="alert$.message"></div>
      <div *ngIf="alert$.showDefaultButtons" class="modal-footer">
        <button *ngIf="alert$.showDismissButton" type="button" class="btn btn-rtn-inv btn-90" data-dismiss="modal"
                (click)="modal.dismiss()" [innerHTML]="alert$.dismissButtonLabel" autofocus></button>
        <button *ngIf="alert$.showCloseButton" type="button" class="btn btn-rtn btn-90" (click)="modal.close()"
                [innerHTML]="alert$.closeButtonLabel"></button>
      </div>
    </modal>
  